/**
 * @param {EventTarget | null} target
 * @param {Event | undefined} nativeEvent
 */
export function isSpottingObjectsMagnifierExcluded(target, nativeEvent) {
  if (typeof Element === 'undefined') {
    return false;
  }
  const exclusionSelector = [
    'button',
    'a[href]',
    'input',
    'textarea',
    'select',
    '[role="button"]',
    '[contenteditable="true"]',
    '[data-spotting-magnifier-exclude="true"]',
    '.custom-dropdown',
    '.custom-dropdown-list',
  ].join(', ');

  const path = typeof nativeEvent?.composedPath === 'function' ? nativeEvent.composedPath() : [];
  for (const node of path) {
    if (node instanceof Element && node.matches(exclusionSelector)) {
      return true;
    }
  }
  if (target instanceof Element) {
    return Boolean(target.closest(exclusionSelector));
  }
  return false;
}

/**
 * @param {number} clientX
 * @param {number} clientY
 * @param {DOMRect} rect
 * @returns {{ x: number, y: number } | null}
 */
export function clientPointToArenaLocal(clientX, clientY, rect) {
  if (!(rect.width > 0) || !(rect.height > 0)) {
    return null;
  }
  const x = clientX - rect.left;
  const y = clientY - rect.top;
  if (x < 0 || y < 0 || x > rect.width || y > rect.height) {
    return null;
  }
  return { x, y };
}

/**
 * @param {{ x: number, y: number }} point arena-local px
 * @param {number} zoom
 */
export function buildMagnifierZoomTransform(point, zoom) {
  return `translate(${point.x}px, ${point.y}px) scale(${zoom}) translate(${-point.x}px, ${-point.y}px)`;
}
